import * as React from 'react';
import { TApiProcessFile } from '../../../types/Process';
import { ChangeEvent } from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import Accordion from '@mui/material/Accordion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import DescriptionIcon from '@mui/icons-material/Description';
import ListItemText from '@mui/material/ListItemText';

interface IDescriptionProps {
  description: string;
  processFiles?: Array<TApiProcessFile>;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
  handleFileClick: (filePath: string) => () => void | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
  })
);

const Description: React.FC<IDescriptionProps> = ({
  description,
  processFiles,
  expanded,
  handleFileClick,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange('expandedDescription')}
      key={'expandedDescription'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`expandedDescriptionbh-content`}
        id={`expandedDescriptionbh-header`}
      >
        <Typography className={classes.heading}>{t("process.overall_description")}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        {description && (
          <Typography dangerouslySetInnerHTML={{ __html: description }} />
        )}
        {processFiles && processFiles.map((file) => (
          <ListItem
            key={file.id}
            role={undefined}
            dense
            button
            onClick={handleFileClick(file.media)}
          >
            <ListItemIcon>
              <DescriptionIcon/>
            </ListItemIcon>
            <ListItemText
              primary={file.title}
              secondary={file.notes ? file.notes : null}
            />
          </ListItem>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}

export default Description;